// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6b017f5","455":"a32d42a5","977":"057925d6"}[chunkId] + ".chunk.js";
};